module.exports = __webpack_public_path__ + "img/bank-title-bm.42f8e4b6.png";